import React from 'react';
import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import { InputFields } from './components/InputFields/InputFields';
import classNames from 'classnames';
import style from './EditForm.module.scss';

interface IEditForm {
	isVisible: boolean;
}

const EditForm: React.FC<IEditForm> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses}>
			<WithAdditionalValidationState>
				<InputFields />
			</WithAdditionalValidationState>
		</div>
	);
};

export default React.memo(EditForm);
